import { createLink } from '@tanstack/react-router'
import type { AnchorHTMLAttributes, Ref } from 'react'
import { cn } from '@/shared/lib'
import { Icon, type IconName } from '@/shared/ui/icon'

interface EntityAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  icon?: IconName
  mono?: boolean
  ref?: Ref<HTMLAnchorElement>
}

function EntityAnchor({ icon, mono, className, children, ...rest }: EntityAnchorProps) {
  return (
    <a
      className={cn(
        'inline-flex max-w-full items-center gap-1 text-body-sm text-link underline-offset-2 transition-opacity hover:underline hover:opacity-90',
        mono && 'font-mono',
        className,
      )}
      {...rest}
    >
      {icon && <Icon name={icon} size={14} className="shrink-0 opacity-70" />}
      <span className="truncate">{children}</span>
    </a>
  )
}

// Ссылка на сущность: типизированные to/params роутера + единый вид кросс-ссылки.
export const EntityLink = createLink(EntityAnchor)
